let cachedCatalogPromise;

const CATEGORY_COMBOS = [
  [1, 2, 4],
  [5, 7, 8],
  [1, 6, 9],
  [2, 3, 5],
  [4, 6, 9],
  [1, 8, 5],
];

function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function sanitiseName(name) {
  return name.replace(/[^A-Za-zÀ-ÿ'\- ]/g, '').trim();
}

function parseCatalog(text) {
  const categories = [];
  const lines = text.split(/\r?\n/);
  let current = null;

  for (const rawLine of lines) {
    const line = rawLine.trim();
    if (!line) continue;
    if (line.startsWith('💡')) break;
    if (line.startsWith('---')) continue;

    const categoryMatch = line.match(/(\d+)\.\s+(.+)$/);
    if (categoryMatch) {
      const index = Number.parseInt(categoryMatch[1], 10);
      if (Number.isNaN(index)) continue;
      current = { id: index, label: categoryMatch[2], names: [] };
      categories[index - 1] = current;
      continue;
    }

    if (!current) continue;
    const names = line
      .split(',')
      .map(name => sanitiseName(name))
      .filter(Boolean);
    current.names.push(...names);
  }

  return categories
    .filter(Boolean)
    .map(category => ({
      id: category.id,
      label: category.label,
      names: Array.from(new Set(category.names)),
    }));
}

async function fetchCatalog() {
  const response = await fetch(`${process.env.PUBLIC_URL || ''}/data/Blackface_Sheep_Names.txt`);
  if (!response.ok) {
    throw new Error(`Failed to load name catalog (${response.status})`);
  }
  const text = await response.text();
  return parseCatalog(text);
}

export function loadCatalog() {
  if (!cachedCatalogPromise) {
    cachedCatalogPromise = fetchCatalog().catch(err => {
      cachedCatalogPromise = undefined;
      throw err;
    });
  }
  return cachedCatalogPromise;
}

export function generateSuggestions(uid, catalog, rotation = 0, count = 5) {
  if (!uid || !Array.isArray(catalog) || catalog.length === 0) {
    return [];
  }

  const seed = hashString(uid.toUpperCase());
  const suggestions = [];
  let offset = rotation;

  for (let i = 0; i < CATEGORY_COMBOS.length && suggestions.length < count; i += 1) {
    const combo = CATEGORY_COMBOS[i];
    const currentOffset = offset;
    const parts = combo
      .map(categoryId => {
        const category = catalog[categoryId - 1];
        if (!category || !category.names.length) return null;
        const index = (seed + currentOffset + categoryId * 13) % category.names.length;
        return category.names[index];
      })
      .filter(Boolean);

    if (parts.length === 0) {
      offset += 1;
      continue;
    }

    const candidate = parts.join(' ').trim();
    if (!suggestions.includes(candidate)) {
      suggestions.push(candidate);
    }
    offset += 1;
  }

  return suggestions.slice(0, count);
}
